// extracted by mini-css-extract-plugin
module.exports = {"accordion-container":"styles__accordion-container___326wm"};